import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UnifiedResult } from '@/features/marketplace/types';

const MAX = 3;

interface CompareState {
  items: UnifiedResult[];
  add: (item: UnifiedResult) => void;
  remove: (id: string) => void;
  toggle: (item: UnifiedResult) => void;
  has: (id: string) => boolean;
  clear: () => void;
  isFull: () => boolean;
}

export const useCompareStore = create<CompareState>()(
  persist(
    (set, get) => ({
      items: [],
      add: (item) => {
        const { items } = get();
        if (items.length >= MAX || items.some((i) => i.id === item.id)) return;
        set({ items: [...items, item] });
      },
      remove: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
      toggle: (item) => {
        const { items, add, remove } = get();
        items.some((i) => i.id === item.id) ? remove(item.id) : add(item);
      },
      has: (id) => get().items.some((i) => i.id === id),
      clear: () => set({ items: [] }),
      isFull: () => get().items.length >= MAX,
    }),
    { name: 'uo.compare' },
  ),
);
